<template>
  <div id="app">
    <section>
      <div class="container">
          <b-card class="col-12 col-lg-12">
            <div class="table-responsive">
              <table class="table table-borderless ">
                <thead>
                  <tr class="border-bottom">
                    <th>Room Name</th>
                    <th class="text-left">Time*</th>
                    <th><b-button variant="outline-primary" size="md" class="float-right" @click="fetchSensorData"><i class="fa fa-redo"></i></b-button></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in sensorDataArray" :key="index">
                    <td>{{item.roomName}}</td>
                    <td class="text-left">{{item.time}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card>
          <div class="text-right">
            <small class="text-muted font-italic">*Data automatically updates every 2 minutes.</small>
            <template v-if="lastUpdated">
              <small class="text-muted font-italic">Last Updated: {{lastUpdated}}</small>
            </template>
          </div>
      </div>
    </section>
  </div>
</template>

<script>
/*eslint-disable*/

// import HelloWorld from './components/HelloWorld.vue'
import axios from 'axios'
import {baseApiUrl} from "../config.js";
export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  data() {
    return {
      showTableFlag: false,
      sensorDataArray: [],
      sensorDataElement: {
        roomName: "",
        time: ""
      },
      intervalTime: 1000*120,
      pollingInterval: {},
      lastUpdated: ""
    }
  },
  mounted() {
    const current = this
    current.fetchSensorData()
    current.pollingInterval = setInterval(current.fetchSensorData, current.intervalTime)
  },
  created() {
    // const current = this
    // console.log("created");
    // current.fetchSensorData()
    // var url = baseApiUrl + "sensorDataFetch"
    // axios.get(url).then(response=>{
    //   response.data.forEach(item=>{
    //     console.log(item);
    //     var lineItem = {...current.sensorDataElement}
    //     lineItem.roomName = item.sensorName
    //     lineItem.time = new Date(item.sensorLogTime)
    //     current.sensorDataArray.push(lineItem)
    //   })
    //   current.showTableFlag = true
    // })
  },
  updated() {
    console.log(this.pollingInterval);
  },
  methods: {
    fetchSensorData: function(){
      const current = this
      var url = baseApiUrl + "sensorDataFetch"
      axios.get(url).then(response=>{
        current.sensorDataArray = []
        response.data.forEach(item=>{
          console.log(item);
          var lineItem = {...current.sensorDataElement}
          lineItem.roomName = item.sensorName
          lineItem.time = new Date(item.sensorLogTime)
          current.sensorDataArray.push(lineItem)
        })
        current.lastUpdated = new Date()
        current.showTableFlag = true
      })
    },
    getDate: function(){
      let date = new Date();
      let year = date.getUTCFullYear().toString();
      let month = date.getUTCMonth() + 1;
      month = month.toString().padStart(2, '0');
      let day = date.getUTCDate().toString().padStart(2, '0');
      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let am_pm = date.getHours() >= 12 ? "PM" : "AM";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // let time = hours + ":" + minutes + ":" + seconds + " " + am_pm;
      let time = hours + ":" + minutes + " " + am_pm;
      return year + '-' + month + '-' + day + " " + time;
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  width:100vw;
  height:100vh;
}
body {
  width:100vw;
  height:100vh;
}
</style>
